export default "__VITE_ASSET__Cj1AMkGr__"